export default String.raw`
.check-deligoo {
    width: 768px;
    max-height: 348px;

    .dialog {
        &__header {
            padding: 32px 32px 24px 32px;
        }

        &__content {
            padding: 0 32px 32px 32px;
            gap: 16px;
            align-items: flex-start;
        }

        &__actions {
            padding: 0 0 32px 0;
            width: 100%;
            justify-content: center;
        }
    }

    &__form {
        display: flex;
        gap: 8px;
    }

    &__result {
        display: flex;
        gap: 16px;

        svg {
            flex-shrink: 0;
        }
    }
}
`